import type { GetUserInfoResponse } from '~/types/api/user/getUserInfo';
import { ApiClient } from './base/apiClient';
import type { ApiResponse } from '~/types/api/common/apiResponse';
import type { UpdateWorkStationRequest } from '~/types/api/user/updateWorkStation';
import type { UpdateNoticeConfirmDateRequest } from '~/types/api/user/updateNoticeConfirmDate';

const BASE_PATH = '/user';

/**
 * PLATユーザに関するリポジトリ
 */
export class UserRepository {
  private apiClient: ApiClient;

  constructor(displayId: string) {
    this.apiClient = new ApiClient(displayId);
  }

  /**
   * [sp-api-604] 作業駅更新API
   *
   * @param request リクエスト
   * @returns レスポンス
   */
  async updateWorkStation(
    request: UpdateWorkStationRequest,
  ): Promise<ApiResponse<void>> {
    return await this.apiClient.put(BASE_PATH + '/station', request);
  }

  /**
   * [sp-api-605] お知らせ閲覧日時更新API
   *
   * @param request リクエスト
   * @returns レスポンス
   */
  async updateNoticeConfirmDate(
    request: UpdateNoticeConfirmDateRequest,
  ): Promise<ApiResponse<void>> {
    return await this.apiClient.put(BASE_PATH + '/notice', request);
  }

  /**
   * [sp-api-607] PLATユーザ情報取得API
   *
   * @returns PLAT設定情報（主に作業駅）
   */
  async getUserInfo(): Promise<ApiResponse<GetUserInfoResponse>> {
    return await this.apiClient.get<GetUserInfoResponse>(BASE_PATH + '/info');
  }
}
